import React, { useRef, useState } from "react";
import { BsFillPlayFill, BsPauseFill } from 'react-icons/bs';

import './Intro.css';

export default function Intro(): JSX.Element {
    const [playVideo, setPlayVideo] = useState(false);
    const vidRef  = useRef<HTMLVideoElement>(null);

    return (
        <div className="app__video" id="camera">
            <video
                ref={vidRef}
                src="https://res.cloudinary.com/dy1eb4rez/video/upload/v1774224576/meal_13355fc072.mp4"
                loop
                controls={false}
            />

            <div className="app__video-overlay flex__center">
                <div
                className="app__video-overlay_circle flex__center"
                onClick={() => {
                    setPlayVideo(!playVideo);
                    if (playVideo) {
                    vidRef.current?.pause();
                    } else {
                    vidRef?.current?.play();
                    }
                }}
                >
                {playVideo ? (
                    <BsPauseFill color="#fff" fontSize={30} />
                ) : (
                    <BsFillPlayFill color="#fff" fontSize={30} />
                )}
                </div>
            </div>
            </div>
    )
}